import React from 'react';
import ProductsTotalCount from './ProductsTotalCount';
import PatternImageToggler from './PatternImageToggler';

const MobileProductCountBar = () => {
  return (
    <div className="flex items-center justify-between bg-white py-2">
      <ProductsTotalCount />
      <PatternImageToggler />
    </div>
  );
};

export default MobileProductCountBar;
